import type { CashDenominationRowDto } from './cash-denominations.dto.js';
import type { CashOperationIdentityDto } from './cash-operation-identity.dto.js';

export const cashCustodyReceiptStatusValues = [
  'accepted',
  'matched_pending_ack',
  'pending_reconciliation',
  'matched',
  'reclassified',
  'corrected',
  'exception',
  'reversed',
] as const;
export type CashCustodyReceiptStatus = (typeof cashCustodyReceiptStatusValues)[number];

export const cashCustodyReceiptSourceTypeValues = [
  'treasury_instruction',
  'direct_vault_intake',
  'unclassified_physical_source',
  'custody_receipt_reversal',
] as const;
export type CashCustodyReceiptSourceType = (typeof cashCustodyReceiptSourceTypeValues)[number];

export interface CashCustodyReceiptDto extends CashOperationIdentityDto {
  id: string;
  status: CashCustodyReceiptStatus;
  sourceType: CashCustodyReceiptSourceType;
  sourceReference: string;
  storeId: string;
  locationId: string;
  stationId: string;
  targetVaultCashLocationId: string;
  amountMinor: number;
  denominations: CashDenominationRowDto[] | null;
  evidenceNote: string | null;
  treasuryInstructionId: string | null;
  originalReceiptId: string | null;
  vaultInMovementId: string | null;
  vaultOutMovementId: string | null;
  treasuryOutMovementId: string | null;
  treasuryInMovementId: string | null;
  reconciledByUserId: string | null;
  reconciledAt: string | null;
  exceptionReason: string | null;
  reversedByReceiptId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ListCashCustodyReceiptsRequest {
  companyId: string;
  locationId?: string;
  targetVaultCashLocationId?: string;
  status?: CashCustodyReceiptStatus;
}

export interface ListCashCustodyReceiptsResponse {
  items: CashCustodyReceiptDto[];
}

export interface ReceiveMatchedTreasuryDeliveryRequest {
  companyId: string;
  operationId: string;
  treasuryInstructionId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  targetVaultCashLocationId: string;
  amountMinor: number;
  denominations?: CashDenominationRowDto[] | null;
  occurredAt?: string;
}

export interface ReceiveProvisionalCashDeliveryRequest {
  companyId: string;
  operationId: string;
  sourceReference: string;
  storeId: string;
  locationId: string;
  stationId: string;
  targetVaultCashLocationId: string;
  amountMinor: number;
  denominations?: CashDenominationRowDto[] | null;
  evidenceNote?: string | null;
  occurredAt?: string;
}

export interface ReconcileCashCustodyReceiptRequest {
  companyId: string;
  operationId: string;
  receiptId: string;
  resolution: 'match_treasury_instruction' | 'reclassify_direct_vault_intake' | 'exception';
  treasuryInstructionId?: string | null;
  reason?: string | null;
  occurredAt?: string;
}

export interface ReverseCashCustodyReceiptRequest {
  companyId: string;
  operationId: string;
  receiptId: string;
  reason: string;
  denominations?: CashDenominationRowDto[] | null;
  occurredAt?: string;
}
